import React from "react";

interface Props {
  step: number;
  icon: React.ReactNode;
  title: string;
  description: string;
  color: string;
}

export const StepCard: React.FC<Props> = ({
  step,
  icon,
  title,
  description,
  color,
}) => {
  return (
    <div
      className="h-100 position-relative"
      style={{
        borderRadius: 20,
        background: "#fff",
        padding: "1.6rem 1.4rem",
        boxShadow: "0 12px 40px rgba(0,0,0,0.07)",
        transition: "all .25s ease",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-6px)";
        e.currentTarget.style.boxShadow = "0 20px 60px rgba(0,0,0,0.12)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow = "0 12px 40px rgba(0,0,0,0.07)";
      }}
    >
      {/* STEP NUMBER (ghost, mais elegante) */}
      <div
        style={{
          position: "absolute",
          top: 12,
          right: 16,
          fontSize: "3rem",
          fontWeight: 800,
          color: "rgba(0,0,0,0.035)",
          letterSpacing: "-2px",
          userSelect: "none",
        }}
      >
        {step}
      </div>

      {/* HEADER (ícone + título lado a lado) */}
      <div className="d-flex align-items-center gap-3 mb-3">
        {/* ICON */}
        <div
          className="d-flex align-items-center justify-content-center"
          style={{
            minWidth: 54,
            height: 54,
            borderRadius: 14,
            background: `${color}18`,
            color: color,
            fontSize: 22,
          }}
        >
          {icon}
        </div>

        {/* TITLE */}
        <h5
          className="fw-bold mb-0"
          style={{
            fontSize: "1.05rem",
            lineHeight: 1.2,
          }}
        >
          {title}
        </h5>
      </div>

      {/* DESCRIPTION */}
      <p
        className="text-muted mb-0"
        style={{
          fontSize: "0.9rem",
          lineHeight: 1.7,
        }}
      >
        {description}
      </p>
    </div>
  );
};
